
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host {

    margin-bottom: 3.5rem;

    display: block
}

.hero-provider {

    background-size: cover;

    background-position: center;

    background-repeat: no-repeat;

    color: var(--neutral-white)
}

@media (min-width: 768px) {

    .hero-provider {

        font-size: var(--fs-lg);

        line-height: var(--lh-lg)
    }
}

.background {

    padding-top: 1.75rem;

    padding-bottom: 20rem
}

@media (min-width: 768px) {

    .background {

        padding-top: 4rem
    }

    .background {

        padding-bottom: 18rem
    }
}

.background--green-gradient {

    background-image: var(--green-gradient)
}

.background--blue-gradient {

    background-image: var(--blue-gradient)
}

.background--light-blue {

    background-color: var(--tint-dark-blue)
}

.hero-provider .background--light-blue {

    color: var(--primary-blue-dark)
}

::slotted([slot='breadcrumb']) {

    margin-bottom: 2rem
}

.content {

    margin-top: -20rem
}

@media (min-width: 768px) {

    .content {

        margin-top: -18rem
    }
}
`;